var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h2',[_vm._v("Five Chain")]),_c('JoinForm'),_c('button',{on:{"click":_vm.howToPlayClicked}},[_vm._v("How to Play")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }